import { render, staticRenderFns } from "./WidgetDatatableTabs.vue?vue&type=template&id=e23fba9c&scoped=true"
import script from "./WidgetDatatableTabs.vue?vue&type=script&lang=js"
export * from "./WidgetDatatableTabs.vue?vue&type=script&lang=js"
import style0 from "./WidgetDatatableTabs.vue?vue&type=style&index=0&id=e23fba9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23fba9c",
  null
  
)

export default component.exports